import { decamelizeKeys } from "humps";
import api from "PFCore/api";
import { CustomValue, MetaWithPagination } from "PFTypes";
import { Id } from "PFTypes/id";
import { QueryParams } from "PFTypes/query_params";

export type SkillsFrameworksSuggestedSkillsResponse = {
  entries: CustomValue[];
  meta?: MetaWithPagination;
};

export const fetchSkillsFrameworksSuggestedSkills = (
  id: Id,
  params: QueryParams
): Promise<SkillsFrameworksSuggestedSkillsResponse> =>
  api({
    url: `profiles/${id}/framework_skills`,
    params
  }).then((resp) => decamelizeKeys(resp) as SkillsFrameworksSuggestedSkillsResponse);
